@if (content) {
  <div class="margin-bottom-10">
    <span class="font-weight-bold" dsContent [contentPath]="headerContentRef"></span>
    <div class="flex pad-vertical-10 items-center">
      @if (contentIconPath) {
        <img
          [src]="contentIconPath"
          alt="Vehicle Add Icon"
          class="app-icon inline-display pad-right-10"
        />
      }
      {{ content }}
    </div>
  </div>
}
